<template>
  <!-- :style="{'height':(isShare?'100%':(
    path == '/comonDetailsPage' 
  || path == '/privacyAgreementPage' 
  || path == '/userAgreementPage')?'100%':'calc(100% - '+topHeight+')'),'padding-top':
  (path=='/comonDetailsPage'
  || path == '/privacyAgreementPage' 
  || path == '/userAgreementPage')?0:topHeight}"  -->
  <div id="app" >
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive" :key="$route.fullPath" ></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive" :key="$route.fullPath" ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
    };
  },
  data () {
    return {
      isRouterAlive: true,
      height: '',
      isHorizontal: true,
      path:"",
    };
  },
  watch:{
    $route:{
      handler(val) {
        this.path = val.path
      }
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  }
}
</script>

<style scoped>
#app {
  height: 100%;
  padding-top: unset!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue